/* Premium Product Card v4 - Hover & click variant swatches + Judge.me re-scan */
(function(){
  if(window.__cpv4Init) return;
  window.__cpv4Init = true;

  function swapImage(card, newSrc){
    var img = card.querySelector('.cpv4__img--primary');
    if(!img || !newSrc) return;
    if(img.src === newSrc || img.currentSrc === newSrc) return;
    img.style.transition = 'opacity .18s ease';
    img.style.opacity = '0';
    var done = false;
    var go = function(){
      if(done) return; done = true;
      img.removeAttribute('srcset');
      img.src = newSrc;
      requestAnimationFrame(function(){ img.style.opacity = ''; });
    };
    setTimeout(go, 180);
  }

  function applySwatch(sw){
    if(!sw) return;
    var card = sw.closest('.card-product-v4');
    if(!card) return;
    var newSrc = sw.getAttribute('data-image');
    if(newSrc) swapImage(card, newSrc);
    card.classList.add('card-product-v4--locked');
    card.querySelectorAll('.cpv4__swatch').forEach(function(s){
      s.classList.remove('cpv4__swatch--active');
    });
    sw.classList.add('cpv4__swatch--active');
  }

  /* Hover-to-select with small debounce so quick mouse sweeps don't flicker */
  var hoverTimer = null;
  document.addEventListener('mouseover', function(e){
    var sw = e.target.closest && e.target.closest('.cpv4__swatch');
    if(!sw || sw.classList.contains('cpv4__swatch--more')) return;
    if(sw.classList.contains('cpv4__swatch--active')) return;
    clearTimeout(hoverTimer);
    hoverTimer = setTimeout(function(){ applySwatch(sw); }, 70);
  });
  document.addEventListener('mouseout', function(e){
    var sw = e.target.closest && e.target.closest('.cpv4__swatch');
    if(sw){ clearTimeout(hoverTimer); }
  });

  /* Click also commits (and prevents the card link navigation) */
  document.addEventListener('click', function(e){
    var sw = e.target.closest('.cpv4__swatch');
    if(!sw || sw.classList.contains('cpv4__swatch--more')) return;
    e.preventDefault();
    e.stopPropagation();
    clearTimeout(hoverTimer);
    applySwatch(sw);
  }, false);

  /* Re-trigger Judge.me badge rendering for dynamically-inserted cards */
  function pokeJudgeMe(){
    try {
      if(window.jdgm && window.jdgm.SCRIPT_PREVIEW_BADGE_LOADED){
        if(typeof window.jdgm.refresh === 'function') window.jdgm.refresh();
        if(typeof window.jdgm.loadPreviewBadges === 'function') window.jdgm.loadPreviewBadges();
      }
    } catch(err){}
  }
  if(document.readyState === 'loading'){
    document.addEventListener('DOMContentLoaded', function(){ setTimeout(pokeJudgeMe, 400); });
  } else {
    setTimeout(pokeJudgeMe, 400);
  }
})();
